const TemplateService = {
    mainCard(data) {
        const placesCount = parseInt(data.places_disponibles);
        const isComplet = placesCount <= 0;
        return `
<div class="fc-flexbox-animation-card">
    <div class="event-flex-container">
        <div class="event-time-info">
            ${data.time}
        </div>
        <div class="event-main-info">
            <div class="event-categories">
                ${data.categories ? data.categories.map(cat => {
                    if (typeof cat === 'object' && cat.name) {
                        return `<span class="event-category-tag" style="background-color: ${cat.color || '#4ECDC4'};">${cat.name}</span>`;
                    }
                    return `<span class="event-category-tag">${cat}</span>`;
                }).join('') : ''}
            </div>
            <div class="event-title">${data.title}</div>
            <div class="event-meta-info">
                <div>
                    <i class="bi bi-geo-alt"></i>
                    <span>${data.lieu_depart}</span>
                </div>
                <div>
                    <i class="bi bi-people"></i>
                    <span class="badge ${placesCount > 0 ? 'bg-success' : 'bg-danger'}">
                        <i class="bi bi-person-check me-1"></i>
                        ${placesCount} place${placesCount > 1 ? 's' : ''} disponible${placesCount > 1 ? 's' : ''}
                    </span>
                </div>
            </div>
            <div class="event-actions" style="display: flex !important; visibility: visible !important; margin-top: 1rem !important;">
                <button type="button" class="go-booking-inscription-btn main-card-btn" data-event-id="${data.id}" ${isComplet ? 'disabled' : ''} style="display: inline-flex !important; visibility: visible !important; opacity: 1 !important; position: relative !important; z-index: 10 !important;">
                    <span style="color: #fff !important;">${isComplet ? 'Complet' : 'S\'inscrire'}</span>
                </button>
            </div>
        </div>
        <div class="event-action-area">
            <div class="chevron-icon">
                <svg viewBox="0 0 24 24">
                    <path d="M7.41 8.59L12 13.17l4.59-4.58L18 10l-6 6-6-6 1.41-1.41z"/>
                </svg>
            </div>
        </div>
    </div>
</div>`;
    },

    participantFields(index) {
        return `
            <div class="participant-group" data-index="${index}">
                <div class="participant-header">
                    <h4>Participant ${index + 1}</h4>
                    <button type="button" class="remove-participant-btn">&times;</button>
                </div>
                <div class="form-group">
                    <label for="participants[${index}][nom]">Nom *</label>
                    <input type="text" name="participants[${index}][nom]" required>
                </div>
                <div class="form-group">
                    <label for="participants[${index}][prenom]">Prénom *</label>
                    <input type="text" name="participants[${index}][prenom]" required>
                </div>
                <div class="form-group">
                    <label for="participants[${index}][email]">Email</label>
                    <input type="email" name="participants[${index}][email]">
                </div>
                <div class="form-group">
                    <label for="participants[${index}][telephone]">Téléphone</label>
                    <input type="tel" name="participants[${index}][telephone]">
                </div>
            </div>
        `;
    },

    modalContent(data) {
        const placesCount = parseInt(data.places_disponibles);
        return `
<div class="modal fade" id="inscriptionModal-${data.id}" tabindex="-1" role="dialog" aria-labelledby="inscriptionModalLabel-${data.id}" aria-hidden="true">
    <div class="modal-dialog modal-lg gobooking-modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="inscriptionModalLabel-${data.id}">${data.title}</h5>
                <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div class="modal-body">
                <div class="event-meta mb-4 d-flex flex-wrap">
                    <div class="event-date-time me-3 mb-2">
                        <i class="bi bi-calendar"></i>
                        <span>${data.date}</span>
                        <i class="bi bi-clock"></i>
                        <span>${data.time}</span>
                    </div>
                    <div class="event-location me-3 mb-2">
                        <i class="bi bi-geo-alt"></i>
                        <span>${data.lieu_depart}</span>
                    </div>
                    <div class="event-places mb-2">
                        <i class="bi bi-people"></i>
                        <span class="badge ${placesCount > 0 ? 'bg-success' : 'bg-danger'}">
                            <i class="bi bi-person-check me-1"></i>
                            ${placesCount} place${placesCount > 1 ? 's' : ''} disponible${placesCount > 1 ? 's' : ''}
                        </span>
                    </div>
                </div>
                <div class="event-description mb-4">${data.description}</div>
                <form class="go-booking-form" id="go-booking-inscription-form-${data.id}">
                    <input type="hidden" name="event_id" value="${data.id}">
                    <div class="form-group main-participant">
                        <h4>Participant principal</h4>
                        <div class="participant-fields">
                            <div class="form-group">
                                <label for="name">Nom</label>
                                <input type="text" class="form-control" name="name" required>
                            </div>
                            <div class="form-group">
                                <label for="surname">Prénom</label>
                                <input type="text" class="form-control" name="surname" required>
                            </div>
                            <div class="form-group">
                                <label for="email">Email</label>
                                <input type="email" class="form-control" name="email" required>
                            </div>
                            <div class="form-group">
                                <label for="telephone">Téléphone</label>
                                <input type="tel" class="form-control" name="telephone" required>
                            </div>
                        </div>
                    </div>
                    <div class="additional-participants"></div>
                    <button type="button" class="btn btn-outline-primary add-participant-btn">
                        <i class="bi bi-plus-circle"></i>
                        Ajouter un participant
                    </button>
                </form>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Fermer</button>
                <button type="submit" form="go-booking-inscription-form-${data.id}" class="btn btn-primary">S'inscrire</button>
            </div>
        </div>
    </div>
</div>`;
    },

    eventDetails(data) {
        console.log("TemplateService.eventDetails - données:", {
            id: data.id,
            title: data.title,
            placesCount: parseInt(data.places_disponibles),
            disable_native_inscription: data.disable_native_inscription,
            external_inscription_url: data.external_inscription_url,
            external_inscription_label: data.external_inscription_label
        });
        
        const placesCount = parseInt(data.places_disponibles);
        const isComplet = placesCount <= 0;
        
        // Vérification plus stricte pour l'inscription externe avec conversion explicite
        const hasExternalInscription = 
            (data.disable_native_inscription === true || data.disable_native_inscription === "true" || data.disable_native_inscription === 1 || data.disable_native_inscription === "1") && 
            data.external_inscription_url && 
            data.external_inscription_url.trim() !== '';
        
        console.log("TemplateService - Analyse de l'inscription externe:", {
            disable_native_inscription_value: data.disable_native_inscription,
            disable_native_inscription_type: typeof data.disable_native_inscription,
            has_url: Boolean(data.external_inscription_url),
            is_external_enabled: hasExternalInscription
        });
        
        // Déterminer le type de bouton d'inscription à afficher
        let inscriptionBtnHtml = '';
        if (placesCount > 0) {
            if (hasExternalInscription) {
                // Système d'inscription externe
                inscriptionBtnHtml = `
                <div class="event-actions">
                    <a href="${data.external_inscription_url}" class="go-booking-inscription-btn" target="_blank">
                        ${data.external_inscription_label || 'S\'inscrire à l\'animation'}
                    </a>
                </div>`;
            } else {
                // Système d'inscription native
                inscriptionBtnHtml = `
                <div class="event-actions">
                    <button class="go-booking-inscription-btn" data-event-id="${data.id}">
                        S'inscrire à l'animation
                    </button>
                </div>`;
            }
        }
        
        return `
<div class="fc-flexbox-event-details">
    <div class="event-header">
        <h3>${data.title}</h3>
        ${data.categories ? `
            <div class="event-categories">
                ${data.categories.map(cat => {
                    if (typeof cat === 'object' && cat.name) {
                        return `<span class="event-category-tag" style="background-color: ${cat.color || '#4ECDC4'};">${cat.name}</span>`;
                    }
                    return `<span class="event-category-tag">${cat}</span>`;
                }).join('')}
            </div>
        ` : ''}
    </div>
    <div class="event-info">
        <div class="event-meta d-flex flex-wrap">
            <div class="event-date-time me-3 mb-2">
                <i class="bi bi-calendar"></i>
                <span>${data.date}</span>
                <i class="bi bi-clock"></i>
                <span>${data.time}</span>
            </div>
            <div class="event-location me-3 mb-2">
                <i class="bi bi-geo-alt"></i>
                <span>${data.lieu_depart}</span>
            </div>
            <div class="event-places mb-2">
                <i class="bi bi-people"></i>
                <span class="badge ${placesCount > 0 ? 'bg-success' : 'bg-danger'}">
                    <i class="bi bi-person-check me-1"></i>
                    ${placesCount} place${placesCount > 1 ? 's' : ''} disponible${placesCount > 1 ? 's' : ''}
                </span>
            </div>
        </div>
        <div class="event-description">${data.description}</div>
    </div>
    ${inscriptionBtnHtml}
</div>`;
    },

    inscriptionModal(data) {
        const placesCount = parseInt(data.places_disponibles);
        const maxParticipantsPerUser = parseInt(data.max_inscriptions_user) || 1;
        return `
<div class="modal fade" id="inscriptionModal" tabindex="-1" role="dialog" aria-labelledby="inscriptionModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered gobooking-modal-dialog">
        <div class="modal-content">
            <div class="modal-header">
                <h5 class="modal-title" id="inscriptionModalLabel">${data.title}</h5>
                <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Fermer"></button>
            </div>
            <div class="modal-body">
                <div class="animation-meta mb-3">
                    <div class="d-flex flex-wrap">
                        <div class="me-3 mb-2">
                            <i class="bi bi-calendar"></i>
                            <span>${data.date || 'Date non spécifiée'}</span>
                        </div>
                        <div class="me-3 mb-2">
                            <i class="bi bi-geo-alt"></i>
                            <span>${data.lieu_depart || 'Lieu non spécifié'}</span>
                        </div>
                        <div class="mb-2">
                            <i class="bi bi-people"></i>
                            <span class="badge ${placesCount > 0 ? 'bg-success' : 'bg-danger'}">
                                <i class="bi bi-person-check me-1"></i>
                                ${placesCount} place${placesCount > 1 ? 's' : ''} disponible${placesCount > 1 ? 's' : ''}
                            </span>
                        </div>
                    </div>
                </div>
                <div class="animation-details mb-4"></div>
                <form id="go-booking-inscription-form" class="needs-validation" novalidate>
                    <input type="hidden" name="animation_id" id="animation_id" value="${data.id}">
                    
                    <h5 class="mb-3">Participant principal</h5>
                    <div class="row g-3">
                        <div class="col-md-6">
                            <label for="nom" class="form-label">Nom *</label>
                            <input type="text" class="form-control" id="nom" name="nom" required>
                            <div class="invalid-feedback">
                                Veuillez saisir votre nom
                            </div>
                        </div>
                        <div class="col-md-6">
                            <label for="prenom" class="form-label">Prénom *</label>
                            <input type="text" class="form-control" id="prenom" name="prenom" required>
                            <div class="invalid-feedback">
                                Veuillez saisir votre prénom
                            </div>
                        </div>
                        <div class="col-md-6">
                            <label for="email" class="form-label">Email *</label>
                            <input type="email" class="form-control" id="email" name="email" required>
                            <div class="invalid-feedback">
                                Veuillez saisir une adresse email valide
                            </div>
                        </div>
                        <div class="col-md-6">
                            <label for="telephone" class="form-label">Téléphone *</label>
                            <input type="tel" class="form-control" id="telephone" name="telephone" required>
                            <div class="invalid-feedback">
                                Veuillez saisir votre numéro de téléphone
                            </div>
                        </div>
                    </div>

                    <div class="participants-supplementaires mt-4">
                        <h5 class="mb-3">
                            Participants supplémentaires 
                            <small class="text-muted">(maximum ${maxParticipantsPerUser - 1} par inscription)</small>
                        </h5>
                        <div class="participants-list"></div>
                        <button type="button" class="btn btn-outline-primary w-100 mt-3 add-participant-btn">
                            Ajouter un participant
                        </button>
                    </div>
                </form>
            </div>
            <div class="modal-footer">
                <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
                    Annuler
                </button>
                <button type="button" class="btn btn-primary submit-inscription">
                    Confirmer l'inscription
                </button>
            </div>
        </div>
    </div>
</div>`;
    },

    participantSupplementaire(index) {
        return `
<div class="participant-group card mb-3" data-index="${index}">
    <div class="card-header d-flex justify-content-between align-items-center">
        <h6 class="mb-0">Participant ${index + 1}</h6>
        <button type="button" class="btn-close remove-participant-btn" aria-label="Supprimer"></button>
    </div>
    <div class="card-body">
        <div class="row g-3">
            <div class="col-md-6">
                <label class="form-label">Nom *</label>
                <input type="text" class="form-control" name="participants[${index}][nom]" required>
                <div class="invalid-feedback">
                    Veuillez saisir le nom
                </div>
            </div>
            <div class="col-md-6">
                <label class="form-label">Prénom *</label>
                <input type="text" class="form-control" name="participants[${index}][prenom]" required>
                <div class="invalid-feedback">
                    Veuillez saisir le prénom
                </div>
            </div>
            <div class="col-12">
                <label class="form-label">Email</label>
                <input type="email" class="form-control" name="participants[${index}][email]">
                <div class="invalid-feedback">
                    Veuillez saisir une adresse email valide
                </div>
            </div>
        </div>
    </div>
</div>`;
    }
};

export default TemplateService; 